// ImageCarousel.js
import React from "react";
import { Container, Carousel } from "react-bootstrap";
import './ImageCarousel.css';

const ImageCarousel = () => {
  return (
    <section id="gallery" className="my-5 image-carousel-section">
      <Container>
        <h2 className="text-center mb-4"></h2>
        <Carousel interval={3000} controls indicators fade>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={require("./images/gallery1.jpg")}
              alt="ภาพ 1"
            />
            <Carousel.Caption>
              <h5></h5>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src={require("./images/gallery2.jpg")}
              alt="ภาพ 2"
            />
            <Carousel.Caption>
              <h5></h5>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src={require("./images/gallery3.jpg")}
              alt="ภาพ 3"
            />
            <Carousel.Caption>
              <h5></h5>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>

                  <Carousel.Item>
            <img
              className="d-block w-100"
              src={require("./images/gallery4.jpg")}
              alt="ภาพ 3"
            />
            <Carousel.Caption>
              <h5></h5>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </Container>
    </section>
  );
};

export default ImageCarousel;